<nb-card [accent]="announcement.priority">
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="announcement.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <ngx-view-user-display
            [user]="announcement.author"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago
            [currentDate]="announcement.createdOn"
          ></ngx-view-time-ago>

          <div *ngIf="announcement.refTitle" class="text-link">
            <nb-icon icon="globe-outline"></nb-icon>
            <a class="link" (click)="navigateRef(announcement)">
              {{
                announcement.refTitle.length < 60
                  ? announcement.refTitle
                  : announcement.refTitle.substring(0, 60) + "..."
              }}
            </a>
          </div>

          <div
            *ngIf="!announcement.refTitle || mode == 'detail'"
            class="text-link"
          >
            <nb-icon icon="hash-outline"></nb-icon>
            <ngx-view-tags
              [tags]="announcement.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>

          <div
            *ngIf="
              announcement.createdBy == uid && announcement.category == 'system'
            "
          >
            <button
              nbButton
              ghost
              size="tiny"
              [status]="
                announcement.status == 1
                  ? 'success'
                  : announcement.status == -1
                  ? 'warning'
                  : 'info'
              "
              (click)="edit(announcement)"
            >
              <nb-icon
                [icon]="
                  announcement.status == 1 ? 'eye-outline' : 'eye-off-outline'
                "
              ></nb-icon>
              <span>{{
                announcement.status == 1
                  ? "Xuất bản"
                  : announcement.status == -1
                  ? "Ẩn nội dung"
                  : "Đang thực hiện"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <ngx-button-bookmark
        *ngIf="mode == 'detail'"
        [announcement]="announcement"
      >
      </ngx-button-bookmark>

      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + announcement.id"
        (click)="loadButtonAction(announcement)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="mode != 'detail'">
    <h6 class="link text-heading" (click)="loadContent(true)">
      {{ announcement.title }}
    </h6>
    <div class="content">
      <ngx-view-image
        *ngIf="announcement.coverUrl"
        [imageURL]="announcement.coverUrl"
        (click)="loadContent(true)"
      ></ngx-view-image>

      <div *ngIf="announcement.description" class="text-hint description">
        {{ announcement.description }}
      </div>
    </div>

    <a
      *ngIf="announcement.sourceType && !isMore"
      (click)="loadContent(true)"
      class="link"
    >
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Xem thêm
    </a>

    <nb-card *ngIf="announcement.sourceType && isMore">
      <nb-card-body
        *ngIf="
          announcement.sourceType == 'images' &&
          announcement.imagesUrl.length > 0
        "
      >
        <ngx-view-gallery [imagesUrl]="announcement.imagesUrl">
        </ngx-view-gallery>
      </nb-card-body>

      <nb-card-body
        *ngIf="
          announcement.sourceType == 'video' && announcement.videoUrl != ''
        "
      >
        <ngx-view-video [url]="announcement.videoUrl"></ngx-view-video>
      </nb-card-body>

      <nb-card-body
        *ngIf="
          announcement.sourceType == 'document' && announcement.content != ''
        "
      >
        <ngx-view-document [content]="announcement.content">
        </ngx-view-document>
      </nb-card-body>
    </nb-card>

    <a
      *ngIf="announcement.sourceType && isMore"
      (click)="loadContent(false)"
      class="link"
    >
      <nb-icon icon="chevron-up-outline"></nb-icon>
      Thu gọn
    </a>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-like *ngIf="mode == 'detail'" [announcement]="announcement">
      </ngx-view-like>
      <button
        *ngIf="mode != 'detail'"
        nbButton
        ghost
        shape="semi-round"
        size="small"
      >
        <i class="fas fa-thumbs-up"></i>
        <span>{{ announcement.noLiked | number }} </span>
      </button>

      <button
        *ngIf="announcement.showComments"
        nbButton
        ghost
        status="info"
        size="small"
        (click)="reply()"
      >
        <nb-icon icon="message-square-outline"></nb-icon>

        <div *ngIf="!announcement.noComment || announcement.noComment == 0">
          Bình luận
        </div>

        <div
          *ngIf="announcement.noComment > 0"
          style="text-transform: lowercase"
        >
          &nbsp;Xem <span>{{ announcement.noComment | number }} </span> bình
          luận
        </div>
      </button>

      <ngx-button-report-spam
        [announcement]="announcement"
        (onReport)="report($event)"
      ></ngx-button-report-spam>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-comments
          [announcement]="announcement"
          [mode]="mode"
          (onClose)="closeReply()"
        >
        </ngx-view-comments>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
